module.exports = __webpack_public_path__ + "img/pwjc.5cfe3fbf.5cfe3fbf.png";